export default "__VITE_ASSET__si1e5_eE__"